import React from 'react';

import { TableCell, TableHead, TableRow, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { DATE_FORMAT } from '../../../../constants/date.constant';
import { IFilters } from '../../types';

interface IProps {
  filters: IFilters;
}

const sxTableHead: SxProps<Theme> = { '& th': { fontWeight: 'bold', textAlign: 'center' } };

const StaffStatusEvolutionListHead = React.memo(({ filters }: IProps) => {
  const { t } = useTranslation();

  const [period1Label, setPeriod1Label] = React.useState<string>('');
  const [period2Label, setPeriod2Label] = React.useState<string>('');

  React.useEffect(() => {
    const { period1DateFrom, period1DateTo, period2DateFrom, period2DateTo } = filters;

    const period1 = `${period1DateFrom.format(DATE_FORMAT)} - ${period1DateTo.format(DATE_FORMAT)}`;
    const period2 = `${period2DateFrom.format(DATE_FORMAT)} - ${period2DateTo.format(DATE_FORMAT)}`;

    setPeriod1Label(period1);
    setPeriod2Label(period2);
  }, [filters]);

  return (
    <TableHead className="sticky-header-multiline">
      {filters.school && (
        <TableRow sx={sxTableHead}>
          <TableCell colSpan={4}>{t(`school.${filters.school}`)}</TableCell>
        </TableRow>
      )}

      <TableRow sx={sxTableHead}>
        <TableCell>{t(`general.status`)}</TableCell>

        <TableCell>
          <div>{period1Label}</div>
          <div>{filters.period1SchoolYear}</div>
        </TableCell>

        <TableCell>
          <div>{period2Label}</div>
          <div>{filters.period2SchoolYear}</div>
        </TableCell>

        <TableCell>{t(`general.evolution`)}</TableCell>
      </TableRow>
    </TableHead>
  );
});

export default StaffStatusEvolutionListHead;
